module.exports = __webpack_public_path__ + "static/datatable-center-dont-bf0ec4a8188822fc704c8a83a02a3035.png";